import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { isMerchantIdParentPickerRow, useMerchant } from '../contexts/MerchantContext';
import { buildUrlWithMerchantId } from '../util/helpers';

/**
 * Switches the active merchant and navigates to that merchant's home path (e.g. /settings),
 * instead of keeping the current route and only updating ?merchantId=.
 */
export const useSwitchMerchant = () => {
  const navigate = useNavigate();
  const {
    merchantId,
    getHomePath,
    isChildMerchantOnlyUser,
    parentMerchants,
    selectParentAndLoadChildren,
  } = useMerchant();

  return useCallback(
    (targetMerchantId: string) => {
      if (!targetMerchantId || targetMerchantId === merchantId) {
        return;
      }

      const homeUrl = buildUrlWithMerchantId(getHomePath(), targetMerchantId);

      if (
        isChildMerchantOnlyUser &&
        isMerchantIdParentPickerRow(targetMerchantId, parentMerchants)
      ) {
        const parentPickerRow = parentMerchants!.find((p) => p.merchantId === targetMerchantId);
        if (parentPickerRow) {
          selectParentAndLoadChildren(parentPickerRow);
          navigate(homeUrl);
          return;
        }
      }

      navigate(homeUrl);
    },
    [
      merchantId,
      getHomePath,
      isChildMerchantOnlyUser,
      parentMerchants,
      selectParentAndLoadChildren,
      navigate,
    ],
  );
};
